'use strict'; // eslint-disable-line strict

module.exports = require('./lib/sign_keypairs.js')
